/**
 * Decorative background videos (`<video data-bg-video>`).
 *
 * Playback is motion the CSS `prefers-reduced-motion` rule can't reach — there
 * is no property to stop a video with. So under reduced motion we pause it and
 * strip its sources, then `load()` to drop the buffered stream; with no source
 * left the element falls back to its `poster`, which also spares the download.
 *
 * Nothing to do otherwise: `autoplay muted playsinline` already starts it, and
 * when a browser refuses autoplay (iOS Low Power Mode) the poster stands in.
 */
export function initBackgroundVideo() {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    document.querySelectorAll('video[data-bg-video]').forEach((video) => {
        video.autoplay = false
        video.pause()
        video.removeAttribute('src')
        video.querySelectorAll('source').forEach((source) => source.remove())
        video.load()
    })
}
